import psl_ui from '../../libs/psl_ui.js';
import psl_actions from '../../libs/psl_actions.js';

import analytics from '../analytics/component.js';

import data from '../../data.js';

import state from '../../state.js';

import './style.scss';
import template from './template.pst';

psl_ui.templates.add('top_menu',template);

const {els,rpoints}=psl_ui.templates.render('top_menu',{menu:data.eras});

psl_actions.add({
	'top_menu.toggle':(e,i)=>{
		state.era=i;
		analytics.track_era_toggle(data.eras[i].name);
	},
});

state.events.on('era',_render);

function _render(){
	data.eras.forEach(item=>{
		rpoints[`item_${item.i}`].classList.toggle('active',state.era===item.i);
	});
}

_render();

const _container = document.getElementById('container');

els.forEach(el=>_container.appendChild(el));